import React from 'react';
import { Typography } from '../../Typography/Typography';
import { AlertBox } from '../../AlertBox/AlertBox';
import { VisuallyHidden } from '../../VisuallyHidden/VisuallyHidden';

import useStyles from './ReadOnlyField.style';

interface ReadOnlyFieldProps {
  label: string;
  value: React.ReactNode;
  error?: string | null;
  errorTitle?: string;
  errorSubtitle?: string;
  children: React.ReactElement;
}

export const ReadOnlyField = ({
  label,
  value,
  error,
  errorTitle,
  errorSubtitle,
  children,
}: ReadOnlyFieldProps): JSX.Element => {
  const c = useStyles({});
  return (
    <div className={c.readOnlyFieldWrapper}>
      <VisuallyHidden>{children}</VisuallyHidden>
      <div className={c.readOnlyFieldRow}>
        <Typography component="span" className={c.readOnlyFieldLabel}>{label}</Typography>
        <Typography component="span" fontWeight="bold">{value}</Typography>
      </div>
      {error && errorTitle && (
        <AlertBox className={c.fieldErrorBox} colorStyle="red" title={errorTitle} subtitle={errorSubtitle} />
      )}
    </div>
  );
};
